<template>
	<div class="sfkwrap">
		<div class="top">
			<div class="left_img">
				<img :src="sfk_img" >
			</div>
			<div class="right_words">
				<div class="title">{{sfk_title}}</div>
				<div class="content" v-html="sfk_content"></div>
			</div>
		</div>
		<div class="bottom">
			<div class="title">
				<span :class="{select:select==2}"  @click="select = 2">课件</span>
				<span :class="{select:select==3}"  @click="select = 3">教案</span>
				<span :class="{select:select==1}"  @click="select = 1">视频</span>
			</div>
			<div class="cont">
				<div class="contItem videocontItem" v-if="select == 1 && $route.query.type == 1">
					<!-- 视频 -->
					<div class="item" v-for="item in videoList" @click="goDetail(1,item.id)">
						<div class="top_img">
							<img :src="item.v_img" >
						</div>
						<div class="bottom_words">{{item.title}}</div>
					</div>
				</div>
				<div class="contItem videocontItem" v-if="select == 1 && $route.query.type == 2">
					<!-- 视频 -->
					<div class="item_word" v-for="item in videoList" @click="goDetail(1,item.rid)">
						{{item.name}}
					</div>
				</div>
				<div class="contItem" v-if="select == 2">
					<!-- ppt -->
					<iframe v-if="ppt_url.search('.ppt') == -1" id="iframe1"
					style="margin-top: -50px;height: 750px;background: rgb(82,86,89);"
					allowtransparency='yes'
					:src="ppt_url"></iframe>
					<iframe v-else
					:src="'http://view.officeapps.live.com/op/view.aspx?src='+ppt_url"
					style="margin-top: -90px;height: 790px;background: rgb(82,86,89);"
					allowtransparency='yes'></iframe>
				</div>
				<div class="contItem" v-if="select == 3">
					<!-- pdf -->
					<pdf
						v-for="i in numPages"
						:key="i"
						:src="play_url"
						:page="i"
					></pdf>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import pdf from 'vue-pdf';
	import { detail } from '@/axios';
	export default {
		data(){
			return{
				select:2,
				play_url:"",
				ppt_url:"",
				pdf_url:"",
				videoList:[],
				sfk_title:"数据加载中...",
				sfk_img:"",
				sfk_content:"数据加载中...",
				numPages:0
			}
		},
		components: {pdf},
		methods: {
			getdata(){
				var that = this;
				detail.resouceDetail({
					id:that.$route.query.id,
				}).then(res => {
					if(res.code == 200){
						for (var i = 0; i < res.data.lists.length; i++) {
							if(res.data.lists[i].bs_id == 1){
								that.videoList.push(res.data.lists[i])
							}else if(res.data.lists[i].bs_id == 2){
								//  ppt
								that.ppt_url = res.data.lists[i].v_url
							}else if(res.data.lists[i].bs_id == 4){
								//  pdf
								that.play_url = pdf.createLoadingTask(res.data.lists[i].v_url)
								that.play_url.promise.then(pdf => {
									that.numPages = pdf.numPages;
								});
							}
						}
						that.sfk_title = res.data.title;
						that.sfk_img = res.data.v_img;
						that.sfk_content = res.data.content;
					}
				})
			},
			getdata1(){
				var that = this;
				detail.resouceDetail1({
					id:that.$route.query.id,
				}).then(res => {
					if(res.code == 200){
						for (var i = 0; i < res.data.relation.length; i++) {
							if(res.data.relation[i].bsid == 1){
								that.videoList.push(res.data.relation[i])
							}else if(res.data.relation[i].bsid == 2){
								//  ppt
								that.ppt_url = res.data.relation[i].src
							}else if(res.data.relation[i].bsid == 4){
								//  pdf
								that.play_url = pdf.createLoadingTask(res.data.relation[i].src)
								that.play_url.promise.then(pdf => {
									that.numPages = pdf.numPages;
								});
							}
						}
						that.sfk_title = res.data.title;
						that.sfk_img = res.data.sz_img;
						that.sfk_content = res.data.content;
					}
				})
			},
			// 视频详情
			goDetail(bsid,id){
				var that = this;
				that.$emit("highLight",that.$route.query.index,bsid,id,that.$route.query.type)
			}
		},
		mounted(){
			var that = this;
			if(that.$route.query.type == 1){
				that.getdata();
			}else{
				that.getdata1();
			}
			this.$emit("highLight",this.$route.query.index,"","","");
		}
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	.sfkwrap{
		width: $indexWidth;
		margin: $indexMargin auto;
		.top{
			width: 100%;
			height: 240px;
			display: flex;
			justify-content: space-between;
			.left_img{
				height: 100%;
				width: 360px;
				img{
					width: 100%;
					height: 100%;
					background: rgba($color: #000, $alpha: 0.1);
					object-fit: cover;
				}
			}
			.right_words{
				width: 820px;
				height: 100%;
				.title{
					font-size: 24px;
					color: #333;
					overflow: hidden;
					display: -webkit-box;
					word-break: break-all;
					text-overflow: ellipsis; 
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 1;
					font-weight: bold;
					line-height: 60px;
				}
				.content{
					font-size: 16px;
					line-height: 28px;
					overflow: hidden;
					display: -webkit-box;
					word-break: break-all;
					text-overflow: ellipsis; 
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 6;
				}
			}
		}
		.bottom{
			width: $indexWidth;
			height: 800px;
			margin: $indexMargin auto;
			border: 1px solid #D5D5D5;
			.title{
				background-color:#D5D5D5;
				height: 60px;
				width: 100%;
				font-size: 18px;
				display: flex;
				color: $indexColor1;
				justify-content: center;
				align-items: center;
				line-height: 60px;
				span{
					cursor: pointer;
					padding: 0 30px;
					font-weight: bold;
					border-bottom: 3px solid rgba(0,0,0,0);
				}
				span:hover{
					color: #bb0000;
					font-weight: bold;
					border-bottom: 3px solid #bb0000;
				}
				.select{
					color: #bb0000;
					font-weight: bold;
					border-bottom: 3px solid #bb0000;
				}
			}
			.cont{
				width: 100%;
				box-sizing: border-box;
				padding: 20px 20px;
				height: 740px;
				.contItem{
					width: 100%;
					height: 100%;
					overflow-y: scroll;
					overflow-x: hidden;
					iframe{
						width: 100%;
						height: 100%;
						border: none;
						background: none;
					}
				}
				.contItem::-webkit-scrollbar{
					width: 0px;
				}
				.videocontItem{
					height: 100%;
					width: 100%;
					overflow-y: scroll;
					display: flex;
					flex-wrap: wrap;
					align-content: flex-start;
					.item_word{
						cursor: pointer;
						width: 100%;
						line-height: 55px;
						font-size: 16px;
						height: 55px;
						color: $indexColor;
						border-bottom: 1px solid #DDDDDD;
					}
					.item_word:hover{
						color: #bb0000;
						box-shadow: 0px 5px 5px 0px rgba($color: #000000, $alpha: 0.1);
					}
					.item{
						user-select: none;
						cursor: pointer;
						width: 275px;
						height: 220px;
						margin-right: 20px;
						margin-bottom: 20px;
						box-sizing: border-box;
						border: 1px solid rgba($color: #000, $alpha: 0.1);
						.top_img{
							width: 100%;
							height: 170px;
							overflow: hidden;
							img{
								width: 100%;
								height: 100%;
								object-fit: cover;
								transition: all 0.3s;
							}
						}
						.bottom_words{
							height: 50px;
							line-height: 50px;
							font-size: 16px;
							padding: 0 15px;
							box-sizing: border-box;
							width: 100%;
							overflow: hidden;
							display: -webkit-box;
							word-break: break-all;
							text-overflow: ellipsis; 
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 1;
						}
					}
					.item:nth-child(4n){
						margin-right: 0px;
					}
					.item:hover{
						img{
							transform: scale(1.1);
						}
						.bottom_words{
							color: #bb0000;
						}
					}
				}
				.videocontItem::-webkit-scrollbar{
					width:0;
					height:12px;
				}
			}
		}
	}
</style>
